import React from 'react';
import styles from './LeadershipCard.module.scss';

interface LeadershipCardProps {
    imgSrc: string;
  name:string;
  designation:string
}

const LeadershipCard: React.FC<LeadershipCardProps> = ({ imgSrc,name,designation }) => {
  return (
    <>
    {imgSrc && (
    <div
            className={`${styles.LeadershipCard} d-flex flex-column justify-content-start align-items-stretch p-2 h-100`}
          >
            <img src={imgSrc} alt={name} className="img-fluid" />
            <p className={`para fw-bold text-center mb-0 text-uppercase ${styles.LeaderName}`}><strong>{name}</strong></p>
            <p className={`para text-center mb-0 pt-2 ${styles.leaderPosition}`}>{designation}</p>
          </div>
        )}
        </>
  );
};

export default LeadershipCard;
